<template>
  <div v-if="open" class="vm-detail-panel-card">
    <div class="vm-detail-panel-header">
      <div>
        <p class="vm-detail-panel-eyebrow">VM Image</p>
        <h3 class="vm-detail-panel-title">{{ title }}</h3>
      </div>
      <button type="button" class="vm-detail-close-button" aria-label="Close" @click="closePanel">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="vm-detail-panel-body" v-if="detailData">
      <table class="table table-bordered table-condensed vm-detail-table">
        <tbody>
          <tr v-for="(row, index) in detailData.rows" :key="`row-${index}`">
            <th><div class="text-center">{{ row.label }}</div></th>
            <td><div class="text-center">{{ row.value }}</div></td>
          </tr>
          <tr>
            <th><div class="text-center">Referenced By</div></th>
            <td>
              <template v-if="detailData.referenced_vms && detailData.referenced_vms.length">
                <div class="vm-image-reference-list">
                  <div
                    v-for="(vm, index) in detailData.referenced_vms"
                    :key="`ref-${index}`"
                    class="vm-image-reference-item"
                  >
                    <div class="vm-image-reference-main">
                      <strong>{{ vm.name }}</strong>
                      <span class="vm-image-reference-owner">{{ vm.owner }}</span>
                    </div>
                    <span class="vm-image-reference-status" :class="vm.state_class">{{ vm.state_label }}</span>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="text-center">Not used by any VM.</div>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps({
  shellId: {
    type: String,
    default: 'vm-image-detail-shell'
  }
})

const open = ref(false)
const title = ref('')
const detailData = ref(null)
const panelId = `${props.shellId}-panel`

function handlePanelUpdate(event) {
  const detail = event.detail || {}

  title.value = detail.title || ''
  detailData.value = detail.detailData || null
  open.value = true
}

function handlePanelClear() {
  open.value = false
  title.value = ''
  detailData.value = null
}

function closePanel() {
  const shell = document.getElementById(props.shellId)
  const panel = document.getElementById(panelId)

  handlePanelClear()

  if (panel) {
    panel.setAttribute('aria-hidden', 'true')
  }

  if (shell) {
    shell.classList.remove('vm-detail-shell-open')
  }

  window.sccVmImageDetailUrl = null
  window.sccVmImageDetailId = null
  window.sccVmImageDetailShellId = null
  window.sccVmImageDetailMode = null
}

onMounted(() => {
  const panel = document.getElementById(panelId)

  if (!panel) {
    return
  }

  panel.addEventListener('scc:vm-image-detail:update', handlePanelUpdate)
  panel.addEventListener('scc:vm-image-detail:clear', handlePanelClear)
})

onBeforeUnmount(() => {
  const panel = document.getElementById(panelId)

  if (!panel) {
    return
  }

  panel.removeEventListener('scc:vm-image-detail:update', handlePanelUpdate)
  panel.removeEventListener('scc:vm-image-detail:clear', handlePanelClear)
})
</script>
